module.exports = __webpack_public_path__ + "static/bg2-1813f9d645d23e27edd233139d151be4.jpg";